<template>
	<page>
		<module>
			<company-list v-if="auth('b_freight_company')" ></company-list>
			<deliveryaddress-list v-if="auth('b_deliveryaddress')" ></deliveryaddress-list>
			<address-list v-if="auth('b_after_sale_address')" ></address-list>
			<template-list v-if="auth('b_freight_template')" ></template-list>
		</module>
	</page>
</template>

<script>
  import companyList from './freight_company.vue'
	import deliveryaddressList from './delivery_address.vue'
	import addressList from './logistics_address.vue'
	import templateList from './freight_template.vue'
	
	export default {
		components: {
			companyList,
			deliveryaddressList,
			addressList,
			templateList
		},
		
		props: {
			tab: String
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
</style>
